/* ecombots (placeholder brand) · shared script. Vanilla, no dependencies.
   Shopify: becomes assets/site.js, loaded with defer from theme.liquid. */
(function () {
  var doc = document.documentElement;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (rm) doc.classList.add('rm');

  /* header state + mobile nav */
  var header = document.querySelector('.site-header');
  var toggle = document.querySelector('.nav-toggle');
  if (toggle) toggle.addEventListener('click', function () {
    var open = doc.classList.toggle('nav-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.querySelectorAll('.nav a').forEach(function (a) {
    a.addEventListener('click', function () { doc.classList.remove('nav-open'); if (toggle) toggle.setAttribute('aria-expanded', 'false'); });
  });

  /* signup forms: placeholder handler (replace with Shopify customer form) */
  document.querySelectorAll('form.signup').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var note = f.parentNode.querySelector('.form-note');
      if (note) note.textContent = 'thanks. you are on the list (demo form, nothing was sent).';
    });
  });

  /* reveal on scroll */
  var reveals = document.querySelectorAll('.reveal');
  if (!rm && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* split statement text into words */
  document.querySelectorAll('[data-words]').forEach(function (p) {
    var hl = (p.getAttribute('data-hl') || '').split(',').map(function (s) { return s.trim(); });
    var words = p.textContent.trim().split(/\s+/);
    p.setAttribute('aria-label', p.textContent.trim());
    p.innerHTML = words.map(function (w) {
      var clean = w.replace(/[.,:]/g, '');
      return '<span class="w' + (hl.indexOf(clean) > -1 ? ' hl' : '') + '" aria-hidden="true">' + w + '</span>';
    }).join(' ');
  });

  /* bots: varied timing */
  var bots = Array.prototype.slice.call(document.querySelectorAll('.bot'));
  bots.forEach(function (b, i) { b.style.setProperty('--d', (-(i * 0.47) % 3.6).toFixed(2) + 's'); b.style.setProperty('--b', (-(i * 1.13) % 5.2).toFixed(2) + 's'); });

  /* responsive + lazy video: mobile source on small screens, load and play only when in view */
  var vids = document.querySelectorAll('video[data-src]');
  function loadVid(v) {
    if (v._loaded) return; v._loaded = true;
    var mob = v.getAttribute('data-src-mobile');
    var src = (mob && window.matchMedia('(max-width: 700px)').matches) ? mob : v.getAttribute('data-src');
    var poster = (mob && src === mob) ? v.getAttribute('data-poster-mobile') : null;
    if (poster) v.setAttribute('poster', poster);
    v.src = src;
  }
  vids.forEach(function (v) {
    var mob = v.getAttribute('data-poster-mobile');
    if (mob && window.matchMedia('(max-width: 700px)').matches) v.setAttribute('poster', mob);
  });
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { loadVid(v); if (!rm) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
        else if (v._loaded) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { vio.observe(v); });
  } else vids.forEach(function (v) { loadVid(v); });

  /* sticky buy bar (mobile): show after the hero, hide over the pricing section */
  var buybar = document.querySelector('.buybar');
  var buySec = document.getElementById('buy');
  var heroEl = document.querySelector('.hero');
  function bb() {
    if (!buybar) return;
    var past = heroEl ? heroEl.getBoundingClientRect().bottom < 80 : true;
    var over = false;
    if (buySec) { var r = buySec.getBoundingClientRect(); over = r.top < window.innerHeight && r.bottom > 0; }
    var cta = document.querySelector('.cta'); if (cta && cta.getBoundingClientRect().top < window.innerHeight) over = true;
    buybar.classList.toggle('show', past && !over);
  }
  window.addEventListener('scroll', bb, { passive: true }); bb();

  /* story rail: highlight the step in view */
  var steps = Array.prototype.slice.call(document.querySelectorAll('.ss'));
  var railItems = Array.prototype.slice.call(document.querySelectorAll('.story-rail li'));
  if (steps.length && railItems.length) {
    var setStep = function () {
      var mid = window.innerHeight * 0.45, a = 0;
      steps.forEach(function (st, i) { if (st.getBoundingClientRect().top < mid) a = i; });
      railItems.forEach(function (li, i) { li.classList.toggle('is-active', i === a); li.classList.toggle('is-done', i < a); });
    };
    window.addEventListener('scroll', setStep, { passive: true }); setStep();
  }

  /* figma board: pills step from "not started" to their real status when the board scrolls in */
  var FLOW = ['not started', 'design in progress', 'layout done', 'design done', 'added in klaviyo', 'scheduled', 'sent'];
  var boards = document.querySelectorAll('.fb');
  if (!rm && 'IntersectionObserver' in window) {
    boards.forEach(function (b) {
      var pills = b.querySelectorAll('.fpill[data-final]');
      pills.forEach(function (p) { p.setAttribute('data-s', '0'); p.textContent = FLOW[0]; });
      var bio = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; bio.disconnect();
        pills.forEach(function (p, ci) {
          var fin = +p.getAttribute('data-final'), s = 0;
          (function step() {
            if (s >= fin) return;
            setTimeout(function () { s++; p.setAttribute('data-s', s); p.textContent = FLOW[s]; p.classList.remove('tick'); void p.offsetWidth; p.classList.add('tick'); step(); }, (s === 0 ? 300 + ci * 140 : 0) + 520);
          })();
        });
      }, { threshold: 0.35 });
      bio.observe(b);
    });
  }


  /* roi calculator: live, count-up (instant with reduced motion) */
  document.querySelectorAll('[data-roi]').forEach(function (box) {
    var num = box.querySelector('input[type=number]'), rng = box.querySelector('.roi-range');
    var run = +box.getAttribute('data-run') || 200, once = +box.getAttribute('data-once') || 99;
    var outs = { month: box.querySelector('[data-out=month]'), year: box.querySelector('[data-out=year]'), payback: box.querySelector('[data-out=payback]') };
    var cur = { month: 0, year: 0 }, raf = null;
    var sym = box.getAttribute('data-currency') || '€'; function fmt(v) { return (v < 0 ? '-' : '') + sym + Math.round(Math.abs(v)).toLocaleString('en-US'); }
    function payback(m) {
      if (m <= 0) return 'no savings yet';
      var days = once / (m / 30);
      if (days < 1) return 'under 1 day';
      if (days < 60) return Math.ceil(days) + (Math.ceil(days) === 1 ? ' day' : ' days');
      return Math.ceil(days / 30) + ' months';
    }
    function paint(t) {
      outs.month.textContent = fmt(t.month); outs.year.textContent = fmt(t.year);
    }
    function update(agency) {
      agency = Math.max(0, Math.min(100000, +agency || 0));
      var target = { month: agency - run, year: (agency - run) * 12 - once };
      outs.payback.textContent = payback(target.month);
      box.querySelectorAll('.roi-o').forEach(function (o) { o.classList.toggle('is-neg', target.month <= 0 && !o.querySelector('[data-out=payback]')); });
      if (raf) cancelAnimationFrame(raf);
      if (rm) { cur = target; paint(cur); return; }
      var from = { month: cur.month, year: cur.year }, t0 = performance.now(), dur = 650;
      (function step(now) {
        var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        cur = { month: from.month + (target.month - from.month) * e, year: from.year + (target.year - from.year) * e };
        paint(cur);
        if (k < 1) raf = requestAnimationFrame(step); else { cur = target; paint(cur); raf = null; }
      })(t0);
    }
    function setRange(v) {
      rng.value = v;
      var p = (Math.max(+rng.min, Math.min(+rng.max, v)) - rng.min) / (rng.max - rng.min) * 100;
      rng.style.setProperty('--v', p.toFixed(1) + '%');
    }
    num.addEventListener('input', function () { setRange(+num.value || 0); update(num.value); });
    rng.addEventListener('input', function () { num.value = rng.value; setRange(+rng.value); update(rng.value); });
    setRange(+num.value);
    /* first count-up when the card scrolls into view */
    if (!rm && 'IntersectionObserver' in window) {
      paint(cur);
      var rio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { rio.disconnect(); update(num.value); } }, { threshold: 0.3 });
      rio.observe(box);
    } else update(num.value);
  });

  if (rm) return;

  /* bots hop when their card enters view */
  if ('IntersectionObserver' in window) {
    var hio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var b = en.target; hio.unobserve(b);
        setTimeout(function () { b.classList.add('hop'); setTimeout(function () { b.classList.remove('hop'); }, 800); }, 200 + Math.random() * 500);
      });
    }, { threshold: 0.6 });
    bots.forEach(function (b) { hio.observe(b); });
  }

  /* eyes follow the cursor */
  var mx = -1, my = -1, eyeTick = false;
  function eyes() {
    eyeTick = false;
    var vh = window.innerHeight;
    bots.forEach(function (b) {
      var r = b.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var dx = mx - (r.left + r.width / 2), dy = my - (r.top + r.height / 2);
      var d = Math.sqrt(dx * dx + dy * dy) || 1, k = Math.min(1, d / 260);
      b.style.setProperty('--ex', (dx / d * 4 * k).toFixed(2) + 'px');
      b.style.setProperty('--ey', (dy / d * 3.5 * k).toFixed(2) + 'px');
    });
  }
  window.addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; if (!eyeTick) { eyeTick = true; requestAnimationFrame(eyes); } }, { passive: true });

  /* team pinning only where the grid fits on one screen */
  var teamMq = window.matchMedia('(min-width: 1081px) and (min-height: 720px)');
  function setTeamPin() { doc.classList.toggle('team-pin', teamMq.matches); }
  setTeamPin();
  if (teamMq.addEventListener) teamMq.addEventListener('change', setTeamPin);

  var hero = document.querySelector('.hero');
  var statements = Array.prototype.slice.call(document.querySelectorAll('.statement'));
  var pipes = Array.prototype.slice.call(document.querySelectorAll('.pipeline'));
  var teams = Array.prototype.slice.call(document.querySelectorAll('.team'));
  var zooms = Array.prototype.slice.call(document.querySelectorAll('[data-scrub]'));

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function pinProgress(el) {
    var r = el.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
  }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  /* deterministic scatter for team cards */
  teams.forEach(function (t) {
    t._cards = Array.prototype.slice.call(t.querySelectorAll('.role'));
    t._count = t.querySelector('[data-count]');
    t._cards.forEach(function (c, i) {
      var a = (i * 137.5) * Math.PI / 180;
      c._dx = Math.cos(a) * (28 + (i % 3) * 10);   /* vw */
      c._dy = Math.sin(a) * (30 + (i % 4) * 8) + 18; /* vh */
      c._rot = ((i % 5) - 2) * 7;
    });
  });
  pipes.forEach(function (p) {
    p._items = Array.prototype.slice.call(p.querySelectorAll('.rail li'));
    p._pds = Array.prototype.slice.call(p.querySelectorAll('.pd'));
    p._rail = p.querySelector('.rail');
    p._last = -1;
  });
  statements.forEach(function (s) { s._w = Array.prototype.slice.call(s.querySelectorAll('.w')); });

  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);

    if (hero) {
      var hp = clamp(window.scrollY / Math.max(1, hero.offsetHeight), 0, 1);
      hero.style.setProperty('--hp', hp.toFixed(4));
    }

    statements.forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      var p = pinProgress(s);
      var n = s._w.length, lit = Math.round(clamp(p * 1.25, 0, 1) * n);
      for (var i = 0; i < n; i++) s._w[i].classList.toggle('lit', i < lit);
    });

    pipes.forEach(function (pl) {
      var r = pl.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      var p = pinProgress(pl), n = pl._items.length;
      var active = Math.min(n - 1, Math.floor(p * n * 0.999));
      if (pl._rail) pl._rail.style.setProperty('--p', (n > 1 ? active / (n - 1) : 1).toFixed(4));
      if (active === pl._last) return;
      pl._last = active;
      pl._items.forEach(function (li, i) {
        li.classList.toggle('is-active', i === active);
        li.classList.toggle('is-done', i < active);
      });
      pl._pds.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
    });

    var pinned = doc.classList.contains('team-pin');
    teams.forEach(function (t) {
      if (!pinned) {
        if (t._dirty) { t._cards.forEach(function (c) { c.style.transform = ''; c.style.opacity = ''; }); t._dirty = false; }
        return;
      }
      var r = t.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      t._dirty = true;
      var p = pinProgress(t), n = t._cards.length, placed = 0;
      t._cards.forEach(function (c, i) {
        var start = (i / n) * 0.55;
        var k = easeOut(clamp((p - start) / 0.35, 0, 1));
        if (k > 0.98) placed++;
        var inv = 1 - k;
        c.style.transform = 'translate3d(' + (c._dx * inv).toFixed(2) + 'vw,' + (c._dy * inv).toFixed(2) + 'vh,0) rotate(' + (c._rot * inv).toFixed(2) + 'deg) scale(' + (0.86 + 0.14 * k).toFixed(3) + ')';
        c.style.opacity = (0.08 + 0.92 * k).toFixed(3);
      });
      if (t._count) t._count.textContent = placed;
    });

    zooms.forEach(function (z) {
      var r = z.getBoundingClientRect();
      if (r.top > vh) { z.style.setProperty('--p', '0'); return; }
      if (r.bottom < 0) { z.style.setProperty('--p', '1'); return; }
      var p = clamp((vh - r.top) / (vh * 0.85), 0, 1);
      z.style.setProperty('--p', easeOut(p).toFixed(4));
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  frame();
})();
